import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EmailService } from '../../../core/services/email.service';
import { EmailDetail } from '../../../core/models/app.models';

/**
 * Sdílený detail e-mailu — obsah (jen text, žádné HTML), přílohy jako odkazy
 * a navázané přestupy (odpojit / napojit přes app-transfer-select). Použije jak
 * obrazovka Komunikace (feature `communication`), tak detail přestupu, proto žije
 * v SharedModule a ne pod features/communication.
 */
@Component({
  selector: 'app-email-detail',
  templateUrl: './email-detail.component.html',
  styleUrls: ['./email-detail.component.scss']
})
export class EmailDetailComponent implements OnChanges {
  @Input() emailId!: number;

  email: EmailDetail | null = null;
  loading = false;
  linkTransferId: number | null = null;

  statusLabels: { [k: number]: string } = { 1: 'Čeká na analýzu', 2: 'Zpracováno', 3: 'Chyba' };
  transferStatusLabels: { [k: number]: string } = {
    1: 'K vyřešení', 2: 'Čeká se na protistranu', 3: 'Čeká se na podpisy',
    4: 'Potvrzení FAČR', 5: 'Vyřešeno', 6: 'Stornováno'
  };

  constructor(private emailService: EmailService, private messageService: MessageService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['emailId'] && this.emailId) { this.load(); }
  }

  private load(): void {
    this.loading = true;
    this.emailService.getById(this.emailId).subscribe({
      next: e => { this.email = e; this.loading = false; },
      error: () => { this.loading = false; }
    });
  }

  linkToTransfer(): void {
    if (!this.linkTransferId || !this.email) { return; }
    this.emailService.link(this.email.id, this.linkTransferId).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Přestup navázán' });
        this.linkTransferId = null;
        this.load();
      },
      error: () => this.messageService.add({ severity: 'error', summary: 'Navázání se nezdařilo' })
    });
  }

  unlink(transferId: number): void {
    if (!this.email) { return; }
    this.emailService.unlink(this.email.id, transferId).subscribe({
      next: () => { this.messageService.add({ severity: 'success', summary: 'Přestup odpojen' }); this.load(); },
      error: () => this.messageService.add({ severity: 'error', summary: 'Odpojení se nezdařilo' })
    });
  }
}
